import { useMutation } from '@tanstack/react-query';

import { postStatisticsReceiptDownload } from '../api';

export const useStatisticsReceiptDownload = () => {
  return useMutation({
    mutationKey: 'statisticsReceiptDownload',
    mutationFn: (params) => postStatisticsReceiptDownload(params),
  });
};
